const SDK_VERSION = '8.33.1';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
